var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdditionalInfo = function SvgAdditionalInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 4.25C6.75 4.66421 6.41421 5 6 5C5.58579 5 5.25 4.66421 5.25 4.25C5.25 3.83579 5.58579 3.5 6 3.5C6.41421 3.5 6.75 3.83579 6.75 4.25Z",
    fill: "#004ECC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 8.5V7.5H5.5V6.5H5V5.5H6C6.27614 5.5 6.5 5.72386 6.5 6V7.5H7.25V8.5H4.75Z",
    fill: "#004ECC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6C11 8.76142 8.76142 11 6 11ZM6 10C8.20914 10 10 8.20914 10 6C10 3.79086 8.20914 2 6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10Z",
    fill: "#004ECC"
  })));
};
export { SvgAdditionalInfo as ReactComponent };
export default __webpack_public_path__ + "assets/4861afa9.svg";